import React from "react";

const FareDisclaimer: React.FC = () => {
    return (
        <div className="max-w-[1200px] mx-auto">
            <div className="bg-white border-l-4 border-[#0047ba] rounded-lg">
                <div className="flex items-start gap-3 px-4 pt-3">
                    {/* Info icon */}
                    <div className="flex-shrink-0 mt-0.5">
                        <div className="w-6 h-6 bg-[#0047ba] rounded-full flex items-center justify-center">
                            <span className="text-white text-[13px] font-bold">
                                i
                            </span>
                        </div>
                    </div>

                    {/* Disclaimer text */}
                    <div className="text-[13px] text-gray-700 leading-relaxed">
                        <span className="font-semibold">Fare disclaimer:</span>{" "}
                        Fares are ALL-IN and not guaranteed until final
                        purchase. Prices INCLUDE government taxes and surcharges
                        EXCEPT Philippine Travel Tax, other charges and fees
                        that are collected at the airport. Taxes and fees are
                        approximate (exact amount will be displayed in the next
                        page.). There may be{" "}
                        <a href="#" className="text-[#0047ba] underline">
                            additional fees
                        </a>{" "}
                        for your checked baggage in excess of your free baggage
                        allowance. Price is for one traveler and includes taxes.
                    </div>
                </div>

                {/* See more details link */}
                <div className="px-4 pb-3 ml-9">
                    <a
                        href="#"
                        className="text-[#0047ba] text-[13px] underline"
                    >
                        See more details
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FareDisclaimer;
